/* eslint-disable @typescript-eslint/no-unused-vars,@typescript-eslint/no-explicit-any */
import DefaultPaletteOptions from '../defaultPallete';

export default (theme: DefaultPaletteOptions): any => {
  return {
    styleOverrides: {
      root: {
        minWidth: '250px',
        minHeight: '56px',
        fontSize: '16px',
        color: 'unset !important',
        '& .MuiInputBase-input': {
          fontSize: '16px',
          color: '#000',
        },
        '& .Mui-focused': {
          color: '#767676',
        },
      },
    },
  };
};
